<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.terminations.confirm_title')"
        :message="__('customers.terminations.confirm_message')"
        is-confirm
        is-error
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @confirm="cancelContractTerminationConfirm"
        @close="$emit('close-modal')"
    >
        <div style="padding: 20px;">
            <DRow style="margin-bottom: 10px;">
                <DCol style="display: flex; align-items: center; gap: 1rem;">
                    <DSwitch
                        v-model="send_cancellation_email"
                        color="success"
                        variant="3d"
                    />
                    <label style="margin-bottom: 0;">{{ __('customers.terminations.send_cancel_termination_email') }}</label>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'CancelContractTerminationModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: '',
            incident_id: null,
            send_cancellation_email: true
        }
    },
    methods: {
        cancelContractTerminationConfirm () {
            this.$inertia.delete(this.$route('customers.customers.contracts.terminations.destroy', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                termination: this.contract.termination.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters,
                incident_id: this.incident_id,
                send_cancellation_email: this.send_cancellation_email
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        },
        setIncident (value) {
            this.incident_id = value
        }
    }
}
</script>
